import { FontAwesomeIcons } from "../constants/fontAwesomeIcons";
import * as Dtos from '../dtos/Tmd.dtos';
import * as AuthenticationHelper from '../helpers/authentication';
import { INavItem } from "../components/layouts";

export function SettingsSubMenu(permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GeneralSettingsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.COG,
            title: "General",
            url: "/settings/general",
            description: "Manage general system settings, including categories, roles, and professional disciplines."
        });
    }

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProjectView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CLIPBOARD,
            title: "Project",
            url: "/settings/project",
            description: "Configure project related templates and settings."
        });
    }

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialSettingsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.TRIAL,
            title: "Trial",
            url: "/settings/trial",
            description: "Manage trial related templates and settings."
        });
    }

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialInstitutionSettingsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.TRIALINSTITUTION,
            title: "Trial Institution",
            url: "/settings/trialinstitution",
            description: "Manage trial institution related templates and settings."
        });
    }

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupSettingsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.TRIALGROUP,
            title: "Trial Group",
            url: "/settings/trialgroup",
            description: "Manage trial group related templates and settings."
        });
    }

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupSettingsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.GROUP,
            title: "Group",
            url: "/settings/group",
            description: "Set up and manage research or study groups."
        });
    }

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionSettingsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.INSTITUTION,
            title: "Institution",
            url: "/settings/institution",
            description: "Manage site locations, key contacts, and institution types."
        });
    }

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.QaSettingsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.QA,
            title: "QA",
            url: "/settings/qa",
            description: "Configure quality assurance settings, including forms and reporting tags."
        });
    }

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.OpenClinicaUserRolesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.OPENCLINICA,
            title: "OpenClinica User Roles",
            url: "/settings/openclinicauserroles",
            description: "Manage OpenClinica user roles and permissions."
        });
    }

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.HrecView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.HANDHOLDINGHEART,
            title: "HREC Manager",
            url: "/settings/hrecs",
            description: "Manage Human Research Ethics Committee (HREC) settings."
        });
    }

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.HealthDistrictView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.HOSPITALS,
            title: "Health District Manager",
            url: "/settings/healthdistricts",
            description: "Oversee health district configurations and related settings."
        });
    }

    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/settings"
    });

    return menu;
};

export function GroupSubMenu(groupId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: "/groups/" + groupId + "/details",
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.TRIAL,
            title: "Trials",
            url: "/groups/" + groupId + "/trials",
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialPersonnelRoleView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.USER,
            title: "Personnel",
            url: "/groups/" + groupId + "/personnel",
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupItemTemplatesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.I,
            title: "Items",
            url: "/groups/" + groupId + "/items",
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupNotesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.NOTESMEDICAL,
            title: "Notes",
            url: "/groups/" + groupId + "/notes",
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupFinanceView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN,
            title: "Finance",
            url: "/groups/" + groupId + "/finances",
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupContractView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FILECONTRACT,
            title: "Contracts",
            url: "/groups/" + groupId + "/contracts",
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/groups"
    });

    return menu;
};

export function GroupPersonnelSubMenu(groupId: number, personnelId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupNotesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/groups/${groupId}/personnel/${personnelId}/details`
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/groups/${groupId}/personnel`
    });

    return menu;
};

export function GroupNoteSubMenu(groupId: number, noteId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupNotesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/groups/${groupId}/notes/${noteId}/details`
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/groups/${groupId}/notes`
    });

    return menu;
};

export function CommitteeSubMenu(committeeId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: "/committees/" + committeeId + "/details",
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupPersonnelRoleView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.HANDSHAKE,
            title: "Meetings",
            url: "/committees/" + committeeId + "/meetings",
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialPersonnelRoleView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.USER,
            title: "Members",
            url: "/committees/" + committeeId + "/members",
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupPersonnelRoleView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CALENDARCIRCLEUSER,
            title: "Regular Invitees",
            url: "/committees/" + committeeId + "/regularinvitees",
        });
    }
    // if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupNotesView)) {
    //     menu.push({
    //         icon: FontAwesomeIcons.Duotone.NOTESMEDICAL,
    //         title: "Notes",
    //         url: "/groups/" + committeeId + "/notes",
    //     });
    // }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/committees"
    });

    return menu;
};

export function CommitteeMeetingSubMenu(committeeMeeting: Dtos.CommitteeMeeting, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.CommitteeMeetingView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: "/committees/" + committeeMeeting.committeeId + "/meetings/" + committeeMeeting.id + "/details",
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.CommitteeMeetingAttendanceView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CLIPBOARDUSER,
            title: "Attendance",
            url: "/committees/" + committeeMeeting.committeeId + "/meetings/" + committeeMeeting.id + "/attendances",
        });
    }
    
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/committees/" + committeeMeeting.committeeId + "/meetings"
    });

    return menu;
};

export function CommitteeMemberSubMenu(committeeId: number, committeeMemberId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.CommitteeMemberView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/committees/${committeeId}/members/${committeeMemberId}/details`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.CommitteeMemberRoleView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.USERSHIELD,
            title: "Roles",
            url: `/committees/${committeeId}/members/${committeeMemberId}/roles`,
        });
    }
    
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/committees/${committeeId}/members`
    });

    return menu;
};

export function CommitteeMeetingAttendanceSubMenu(committeeId: number, committeeMeetingId: number, committeeMeetingAttendanceId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.CommitteeMeetingAttendanceView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/committees/${committeeId}/meetings/${committeeMeetingId}/attendances/${committeeMeetingAttendanceId}/details`,
        });
    }
    
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/committees/${committeeId}/meetings/${committeeMeetingId}/attendances`,
    });

    return menu;
};

export function CommitteeMemberRoleSubMenu(committeeId: number, committeeMemberId: number, committeeMemberRoleId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.CommitteeMemberRoleView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: "/committees/" + committeeId + "/members/" + committeeMemberId + "/roles/" + committeeMemberRoleId + "/details",
        });
    }
    
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/committees/" + committeeId + "/members/" + committeeMemberId + "/roles",
    });

    return menu;
};

export function CommitteeRegularInviteeSubMenu(committeeId: number, committeeRegularInviteeId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.CommitteeRegularInviteeView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/committees/${committeeId}/regularinvitees/${committeeRegularInviteeId}/details`,
        });
    }
    
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/committees/${committeeId}/regularinvitees`
    });

    return menu;
};

export function GroupTrialSubMenu(groupId: number, trialId: number, trialGroupId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/details`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialPersonnelRoleView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.USER,
            title: "Personnel",
            url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/personnel`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialItemView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.I,
            title: "Items",
            url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/items`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupLabView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FLASKVIAL,
            title: "Labs",
            url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupFinanceView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN,
            title: "Finance",
            url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/finance`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupContractView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FILECONTRACT,
            title: "Contracts",
            url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/contracts`,
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/groups/${groupId}/trials`
    });

    return menu;
};

export function GroupTrialPersonnelSubMenu(trialGroup: Dtos.TrialGroup, trialPersonnel: Dtos.TrialPersonnel, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupContractView, trialGroup.trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/groups/${trialGroup.groupId}/trials/${trialGroup.trialId}/trialgroup/${trialGroup.id}/personnel/${trialPersonnel.id}/details`,
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/groups/${trialGroup.groupId}/trials/${trialGroup.trialId}/trialgroup/${trialGroup.id}/personnel`
    });

    return menu;
};

export function GroupTrialContractSubMenu(trialGroupContract: Dtos.TrialGroupContract, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupContractView, trialGroupContract.trialGroup.trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/groups/${trialGroupContract.trialGroup.groupId}/trials/${trialGroupContract.trialGroup.trialId}/trialgroup/${trialGroupContract.trialGroupId}/contracts/${trialGroupContract.id}/details`,
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/groups/${trialGroupContract.trialGroup.groupId}/trials/${trialGroupContract.trialGroup.trialId}/trialgroup/${trialGroupContract.trialGroup.id}/contracts`
    });

    return menu;
};

export function GroupTrialLabSubMenu(trialGroupLaboratory: Dtos.TrialGroupLaboratory, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupLabView, trialGroupLaboratory.trialGroup.trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/groups/${trialGroupLaboratory.trialGroup.groupId}/trials/${trialGroupLaboratory.trialGroup.trialId}/trialgroup/${trialGroupLaboratory.trialGroupId}/labs/${trialGroupLaboratory.id}/details`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupLabView, trialGroupLaboratory.trialGroup.trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.USER,
            title: "Personnel",
            url: `/groups/${trialGroupLaboratory.trialGroup.groupId}/trials/${trialGroupLaboratory.trialGroup.trialId}/trialgroup/${trialGroupLaboratory.trialGroupId}/labs/${trialGroupLaboratory.id}/personnel`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupLaboratoryFinanceView, trialGroupLaboratory.trialGroup.trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN,
            title: "Finance",
            url: `/groups/${trialGroupLaboratory.trialGroup.groupId}/trials/${trialGroupLaboratory.trialGroup.trialId}/trialgroup/${trialGroupLaboratory.trialGroupId}/labs/${trialGroupLaboratory.id}/finance`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupLaboratoryContractView, trialGroupLaboratory.trialGroup.trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FILECONTRACT,
            title: "Contracts",
            url: `/groups/${trialGroupLaboratory.trialGroup.groupId}/trials/${trialGroupLaboratory.trialGroup.trialId}/trialgroup/${trialGroupLaboratory.trialGroupId}/labs/${trialGroupLaboratory.id}/contracts`,
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/groups/${trialGroupLaboratory.trialGroup.groupId}/trials/${trialGroupLaboratory.trialGroup.trialId}/trialgroup/${trialGroupLaboratory.trialGroupId}/labs`
    });

    return menu;
};

export function GroupTrialLaboratoryContractSubMenu(trialGroupLaboratoryContract: Dtos.TrialGroupLaboratoryContract, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupLaboratoryContractView, trialGroupLaboratoryContract.trialGroupLaboratory.trialGroup.trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/groups/${trialGroupLaboratoryContract.trialGroupLaboratory.trialGroup.groupId}/trials/${trialGroupLaboratoryContract.trialGroupLaboratory.trialGroup.trialId}/trialgroup/${trialGroupLaboratoryContract.trialGroupLaboratory.trialGroup.id}/labs/${trialGroupLaboratoryContract.trialGroupLaboratory.laboratoryId}/contracts/${trialGroupLaboratoryContract.id}/details`,
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/groups/${trialGroupLaboratoryContract.trialGroupLaboratory.trialGroup.groupId}/trials/${trialGroupLaboratoryContract.trialGroupLaboratory.trialGroup.trialId}/trialgroup/${trialGroupLaboratoryContract.trialGroupLaboratory.trialGroup.id}/labs/${trialGroupLaboratoryContract.trialGroupLaboratory.laboratoryId}/contracts`
    });

    return menu;
};

export function GroupTrialLabPersonnelSubMenu(
    trialId: number, 
    groupId: number,
    trialGroupId: number, 
    trialGroupLaboratoryId: number, 
    trialGroupLaboratoryPersonnelId: number, 
    permissions: Dtos.PersonnelTmdPermissions[]
): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupLabView, trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/personnel/${trialGroupLaboratoryPersonnelId}/details`,
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/groups/${groupId}/trials/${trialId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/personnel`
    });

    return menu;
};

export function TrialGroupSubMenu(groupId: number, trialId: number, trialGroupId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/details`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialPersonnelRoleView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.USER,
            title: "Personnel",
            url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/personnel`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialItemView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.I,
            title: "Items",
            url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/items`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupLabView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FLASKVIAL,
            title: "Labs",
            url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupFinanceView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN,
            title: "Finance",
            url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/finance`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupContractView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FILECONTRACT,
            title: "Contract",
            url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/contracts`,
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialId}/groups`
    });

    return menu;
};

export function TrialGroupPersonnelSubMenu(trialGroup: Dtos.TrialGroup, trialPersonnel: Dtos.TrialPersonnel, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupContractView, trialGroup.trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialGroup.trialId}/groups/${trialGroup.groupId}/trialgroup/${trialGroup.id}/personnel/${trialPersonnel.id}/details`,
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialGroup.trialId}/groups/${trialGroup.groupId}/trialgroup/${trialGroup.id}/personnel`
    });

    return menu;
};

export function TrialGroupContractSubMenu(trialGroupContract: Dtos.TrialGroupContract, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupContractView, trialGroupContract.trialGroup.trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialGroupContract.trialGroup.trialId}/groups/${trialGroupContract.trialGroup.groupId}/trialgroup/${trialGroupContract.trialGroupId}/contracts/${trialGroupContract.id}/details`,
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialGroupContract.trialGroup.trialId}/groups/${trialGroupContract.trialGroup.groupId}/trialgroup/${trialGroupContract.trialGroup.id}/contracts`
    });

    return menu;
};

export function TrialGroupLabSubMenu(trialGroupLaboratory: Dtos.TrialGroupLaboratory, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupLabView, trialGroupLaboratory.trialGroup.trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialGroupLaboratory.trialGroup.trialId}/groups/${trialGroupLaboratory.trialGroup.groupId}/trialgroup/${trialGroupLaboratory.trialGroupId}/labs/${trialGroupLaboratory.id}/details`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupLabView, trialGroupLaboratory.trialGroup.trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.USER,
            title: "Personnel",
            url: `/trials/${trialGroupLaboratory.trialGroup.trialId}/groups/${trialGroupLaboratory.trialGroup.groupId}/trialgroup/${trialGroupLaboratory.trialGroupId}/labs/${trialGroupLaboratory.id}/personnel`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupLaboratoryFinanceView, trialGroupLaboratory.trialGroup.trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN,
            title: "Finance",
            url: `/trials/${trialGroupLaboratory.trialGroup.trialId}/groups/${trialGroupLaboratory.trialGroup.groupId}/trialgroup/${trialGroupLaboratory.trialGroupId}/labs/${trialGroupLaboratory.id}/finance`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupLaboratoryContractView, trialGroupLaboratory.trialGroup.trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FILECONTRACT,
            title: "Contracts",
            url: `/trials/${trialGroupLaboratory.trialGroup.trialId}/groups/${trialGroupLaboratory.trialGroup.groupId}/trialgroup/${trialGroupLaboratory.trialGroupId}/labs/${trialGroupLaboratory.id}/contracts`,
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialGroupLaboratory.trialGroup.trialId}/groups/${trialGroupLaboratory.trialGroup.groupId}/trialgroup/${trialGroupLaboratory.trialGroupId}/labs`
    });

    return menu;
};

export function TrialGroupLaboratoryContractSubMenu(trialGroupLaboratoryContract: Dtos.TrialGroupLaboratoryContract, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupLaboratoryContractView, trialGroupLaboratoryContract.trialGroupLaboratory.trialGroup.trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialGroupLaboratoryContract.trialGroupLaboratory.trialGroup.trialId}/groups/${trialGroupLaboratoryContract.trialGroupLaboratory.trialGroup.groupId}/trialgroup/${trialGroupLaboratoryContract.trialGroupLaboratory.trialGroup.id}/labs/${trialGroupLaboratoryContract.trialGroupLaboratory.laboratoryId}/contracts/${trialGroupLaboratoryContract.id}/details`,
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialGroupLaboratoryContract.trialGroupLaboratory.trialGroup.trialId}/groups/${trialGroupLaboratoryContract.trialGroupLaboratory.trialGroup.groupId}/trialgroup/${trialGroupLaboratoryContract.trialGroupLaboratory.trialGroup.id}/labs/${trialGroupLaboratoryContract.trialGroupLaboratory.laboratoryId}/contracts`
    });

    return menu;
};

export function TrialGroupLabPersonnelSubMenu(
    trialId: number, 
    groupId: number,
    trialGroupId: number, 
    trialGroupLaboratoryId: number, 
    trialGroupLaboratoryPersonnelId: number, 
    permissions: Dtos.PersonnelTmdPermissions[]
): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupLabView, trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/personnel/${trialGroupLaboratoryPersonnelId}/details`,
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialId}/groups/${groupId}/trialgroup/${trialGroupId}/labs/${trialGroupLaboratoryId}/personnel`
    });

    return menu;
};

export function InstitutionSubMenu(institutionId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionView, undefined, institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/institutions/${institutionId}/details`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionDepartmentView, undefined, institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.BUILDINGMEMO,
            title: "Departments",
            url: `/institutions/${institutionId}/departments`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionItemView, undefined, institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.I,
            title: "Items",
            url: `/institutions/${institutionId}/institutionitems`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionPersonnelView, undefined, institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.USER,
            title: "Personnel",
            url: `/institutions/${institutionId}/personnel`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.LabInstitutionView, undefined, institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FLASKVIAL,
            title: "Labs",
            url: `/institutions/${institutionId}/labs`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionNoteView, undefined, institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.NOTESMEDICAL,
            title: "Notes",
            url: `/institutions/${institutionId}/notes`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionProcedureView, undefined, institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.BOOK,
            title: "Procedures",
            url: `/institutions/${institutionId}/procedures`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionFinanceView, undefined, institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN,
            title: "Finance",
            url: `/institutions/${institutionId}/finance`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionContractView, undefined, institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FILECONTRACT,
            title: "Contract",
            url: `/institutions/${institutionId}/contract`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionCodeView, undefined, institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.SQUARECODE,
            title: "Codes",
            url: `/institutions/${institutionId}/codes`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialInstitutionView, undefined, institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.TRIAL,
            title: "Trials",
            url: `/institutions/${institutionId}/trials`
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/institutions"
    });

    return menu;
};

export function InstitutionCodeSubMenu(institutionId: number, institutionCodeId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionNoteView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/institutions/${institutionId}/codes/${institutionCodeId}/details`
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/institutions/${institutionId}/codes`
    });

    return menu;
};

export function InstitutionNoteSubMenu(institutionId: number, noteId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionNoteView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/institutions/${institutionId}/notes/${noteId}/details`
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/institutions/${institutionId}/notes`
    });

    return menu;
};

export function PersonnelSubMenu(personnelId: number, permissions: Dtos.PersonnelTmdPermissions[], fellowships?: Dtos.Fellowship[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.PersonnelView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/personnel/${personnelId}/details`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrainingCertificationsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FILECERTIFICATE,
            title: "Training & Certifications",
            url: `/personnel/${personnelId}/trainingcertifications`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.PersonnelRoleView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.BUILDINGSHIELD,
            title: "Roles",
            url: `/personnel/${personnelId}/roles`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.PersonnelRoleView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.USERSHIELD,
            title: "Permissions",
            url: `/personnel/${personnelId}/permissions`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.PersonnelNoteView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.NOTESMEDICAL,
            title: "Notes",
            url: `/personnel/${personnelId}/notes`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.PersonnelSecurityView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.SHIELDHALVED,
            title: "Login & Security",
            url: `/personnel/${personnelId}/activedirectory`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.PersonnelOpenClinicaView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.OPENCLINICA,
            title: "Open Clinica",
            url: `/personnel/${personnelId}/openclinica`
        });
    }
    if (fellowships && fellowships.length > 0 && AuthenticationHelper.hasPermission(permissions, Dtos.Permission.FellowshipView)){
        menu.push({
            icon: FontAwesomeIcons.Duotone.BULIDINGCOLUMNS,
            title: "Fellowships",
            url: `/personnel/${personnelId}/fellowship/`
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/personnel"
    });

    return menu;
};

export function PersonnelRoleSubMenu(personnelId: number, presonnelRoleId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.PersonnelRoleView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/personnel/${personnelId}/roles/${presonnelRoleId}/details`
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/personnel/${personnelId}/roles`
    });

    return menu;
};

export function PersonnelNoteSubMenu(personnelId: number, noteId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.PersonnelNoteView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/personnel/${personnelId}/notes/${noteId}/details`
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/personnel/${personnelId}/notes`
    });

    return menu;
};

export function TrialSubMenu(trialId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialView, trialId, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialId}/details`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialInstitutionView, trialId, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.INSTITUTION,
            title: "Institutions",
            url: `/trials/${trialId}/institutions`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialItemView, trialId, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.I,
            title: "Items",
            url: `/trials/${trialId}/trialitems`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialItemView, trialId, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.PENFIELD,
            title: "Institution Item Views",
            url: `/trials/${trialId}/trialinstitutionitemviews`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialPersonnelRoleView, trialId, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.USER,
            title: "Personnel",
            url: `/trials/${trialId}/personnel`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialAccrualView, trialId, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CHARTLINE,
            title: "Accrual",
            url: `/trials/${trialId}/accrual`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialNoteView, trialId, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.NOTESMEDICAL,
            title: "Notes",
            url: `/trials/${trialId}/notes`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupView, trialId, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.GROUP,
            title: "Groups",
            url: `/trials/${trialId}/groups`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialDoiView, trialId, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.RIGHTLEFTLARGE,
            title: "Data Sharing",
            url: `/trials/${trialId}/datasharing`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialWebsiteView, trialId, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.GLOBEPOINTER,
            title: "Website",
            url: `/trials/${trialId}/website`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialFinanceView, trialId, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN,
            title: "Finance",
            url: `/trials/${trialId}/finance`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProjectView, trialId, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CLIPBOARD,
            title: "Project",
            url: `/trials/${trialId}/project/details`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialLaboratoryView, trialId, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FLASKVIAL,
            title: "Labs",
            url: `/trials/${trialId}/labs`
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/trials"
    });

    return menu;
};

export function TrialNoteSubMenu(trialId: number, noteId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialNoteView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialId}/notes/${noteId}/details`
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialId}/notes`
    });

    return menu;
};

export function HrecSubMenu(hrecId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.HrecView, undefined, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: "/settings/hrecs/" + hrecId + "/details"
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/settings/hrecs"
    });

    return menu;
};

export function HealthDistrictSubMenu(healthDistrictId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.HealthDistrictView, undefined, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: "/settings/healthdistricts/" + healthDistrictId + "/details"
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/settings/healthdistricts"
    });

    return menu;
};

export function FellowshipSubMenu(personnelId: number, fellowshipId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.FellowshipView, undefined, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/personnel/${personnelId}/fellowship/${fellowshipId}/details`
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/personnel/${personnelId}/details`
    });

    return menu;
};

export function TrialInstitutionSubMenu(trialInstitution: Dtos.TrialInstitution, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    const isExisting: boolean = trialInstitution && trialInstitution.id !== undefined && trialInstitution.id.toString() !== 'create';
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialDetailsView, trialInstitution.trialId, trialInstitution.institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialInstitution.trialId}/trialinstitution/${trialInstitution.id}/details`,
        });
    }
    if (isExisting) {
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialItemView, trialInstitution.trialId, trialInstitution.institutionId)) {
            menu.push({
                icon: FontAwesomeIcons.Duotone.I,
                title: "Items",
                url: `/trials/${trialInstitution.trialId}/trialinstitution/${trialInstitution.id}/items`,
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialPersonnelRoleView, trialInstitution.trialId, trialInstitution.institutionId)) {
            menu.push({
                icon: FontAwesomeIcons.Duotone.USER,
                title: "Personnel",
                url: `/trials/${trialInstitution.trialId}/trialinstitution/${trialInstitution.id}/personnel`,
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialNoteView, trialInstitution.trialId, trialInstitution.institutionId)) {
            menu.push({
                icon: FontAwesomeIcons.Duotone.NOTESMEDICAL,
                title: "Notes",
                url: `/trials/${trialInstitution.trialId}/trialinstitution/${trialInstitution.id}/notes`,
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialInstitutionLabView, trialInstitution.trialId, trialInstitution.institutionId)) {
            menu.push({
                icon: FontAwesomeIcons.Duotone.FLASKVIAL,
                title: "Labs",
                url: `/trials/${trialInstitution.trialId}/trialinstitution/${trialInstitution.id}/labs`,
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialInstitutionFinanceView, trialInstitution.trialId, trialInstitution.institutionId)) {
            menu.push({
                icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN,
                title: "Finance",
                url: `/trials/${trialInstitution.trialId}/trialinstitution/${trialInstitution.id}/finance`,
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialInstitutionContractView, trialInstitution.trialId, trialInstitution.institutionId)) {
            menu.push({
                icon: FontAwesomeIcons.Duotone.FILECONTRACT,
                title: "Contracts",
                url: `/trials/${trialInstitution.trialId}/trialinstitution/${trialInstitution.id}/contracts`,
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.MonitoringView, trialInstitution.trialId, trialInstitution.institutionId)) {
            menu.push({
                icon: FontAwesomeIcons.Duotone.MONITOR,
                title: "Monitoring",
                url: `/trials/${trialInstitution.trialId}/trialinstitution/${trialInstitution.id}/monitoring`,
            });
        }
        menu.push({
            icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
            title: "Back",
            url: `/trials/${trialInstitution.trialId}/institutions`
        });
    }

    return menu;
};

export function TrialInstitutionNoteSubMenu(trialId: number, trialInstitutionId: number, noteId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialNoteView, trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/notes/${noteId}/details`,
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/notes`,
    });

    return menu;
};

export function TrialInstitutionPersonnelSubMenu(trialId: number, trialInstitutionId: number, trialPersonnelId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialPersonnelRoleView, trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/personnel/${trialPersonnelId}/details`,
        });
    }

    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/personnel`
    });

    return menu;
};

export function TrialInstitutionLabSubMenu(trialInstitutionLaboratory: Dtos.TrialInstitutionLaboratory, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialInstitutionLabView, trialInstitutionLaboratory.trialInstitution.trialId, trialInstitutionLaboratory.trialInstitution.institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialInstitutionLaboratory.trialInstitution.trialId}/trialinstitution/${trialInstitutionLaboratory.trialInstitution.id}/labs/${trialInstitutionLaboratory.id}/details`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialInstitutionLabView, trialInstitutionLaboratory.trialInstitution.trialId, trialInstitutionLaboratory.trialInstitution.institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.USER,
            title: "Personnel",
            url: `/trials/${trialInstitutionLaboratory.trialInstitution.trialId}/trialinstitution/${trialInstitutionLaboratory.trialInstitution.id}/labs/${trialInstitutionLaboratory.id}/personnel`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialInstitutionLaboratoryFinanceView, trialInstitutionLaboratory.trialInstitution.trialId, trialInstitutionLaboratory.trialInstitution.institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN,
            title: "Finance",
            url: `/trials/${trialInstitutionLaboratory.trialInstitution.trialId}/trialinstitution/${trialInstitutionLaboratory.trialInstitution.id}/labs/${trialInstitutionLaboratory.id}/finance`,
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialInstitutionLaboratoryContractView, trialInstitutionLaboratory.trialInstitution.trialId, trialInstitutionLaboratory.trialInstitution.institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FILECONTRACT,
            title: "Contracts",
            url: `/trials/${trialInstitutionLaboratory.trialInstitution.trialId}/trialinstitution/${trialInstitutionLaboratory.trialInstitution.id}/labs/${trialInstitutionLaboratory.id}/contracts`,
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialInstitutionLaboratory.trialInstitution.trialId}/trialinstitution/${trialInstitutionLaboratory.trialInstitution.id}/labs`
    });

    return menu;
};

export function TrialInstitutionLabPersonnelSubMenu(
    trialId: number, 
    trialInstitutionId: number, 
    trialInstitutionLaboratoryId: number, 
    trialInstitutionLaboratoryPersonnelId: number, 
    permissions: Dtos.PersonnelTmdPermissions[]
): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialInstitutionLabView, trialId, null)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}/personnel/${trialInstitutionLaboratoryPersonnelId}/details`,
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/labs/${trialInstitutionLaboratoryId}/personnel`
    });

    return menu;
};

export function TrialInstitutionContractSubMenu(trialInstitutionContract: Dtos.TrialInstitutionContract, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialInstitutionContractView, trialInstitutionContract.trialInstitution.trialId, trialInstitutionContract.trialInstitution.institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialInstitutionContract.trialInstitution.trialId}/trialinstitution/${trialInstitutionContract.trialInstitution.id}/contracts/${trialInstitutionContract.id}/details`,
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialInstitutionContract.trialInstitution.trialId}/trialinstitution/${trialInstitutionContract.trialInstitution.id}/contracts`
    });

    return menu;
};

export function TrialInstitutionLaboratoryContractSubMenu(trialInstitutionLaboratoryContract: Dtos.TrialInstitutionLaboratoryContract, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialInstitutionLaboratoryContractView, trialInstitutionLaboratoryContract.trialInstitutionLaboratory.trialInstitution.trialId, trialInstitutionLaboratoryContract.trialInstitutionLaboratory.trialInstitution.institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialInstitutionLaboratoryContract.trialInstitutionLaboratory.trialInstitution.trialId}/trialinstitution/${trialInstitutionLaboratoryContract.trialInstitutionLaboratory.trialInstitution.id}/labs/${trialInstitutionLaboratoryContract.trialInstitutionLaboratory.id}/contracts/${trialInstitutionLaboratoryContract.id}/details`,
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialInstitutionLaboratoryContract.trialInstitutionLaboratory.trialInstitution.trialId}/trialinstitution/${trialInstitutionLaboratoryContract.trialInstitutionLaboratory.trialInstitution.id}/labs/${trialInstitutionLaboratoryContract.trialInstitutionLaboratory.id}/contracts`
    });

    return menu;
};

export function InstitutionTrialSubMenu(trialInstitution: Dtos.TrialInstitution): INavItem[] {

    if (!trialInstitution) {
        return [];
    }
    return [
        {
            icon: undefined,
            title: "Details",
            url: "/institutiontrials/" + trialInstitution.id + "/details",
            // current: current == "institution"
        },
        {
            icon: undefined,
            title: "Items",
            url: "/institutiontrials/" + trialInstitution.id + "/items",
            // current: current == "items"
        },
        {
            icon: undefined,
            title: "Personnel",
            url: "/institutiontrials/" + trialInstitution.id + "/personnel",
            // current: current == "personnel"
        },
        {
            icon: undefined,
            title: "Notes",
            url: "/institutiontrials/" + trialInstitution.id + "/notes",
            // current: current == "notes"
        }
    ];
};

export function ProjectSubMenu(projectId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProjectView, undefined, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: "/projects/" + projectId + "/details"
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProjectDiscussionView, undefined, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.COMMENTS,
            title: "Discussions",
            url: "/projects/" + projectId + "/discussions"
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProjectView, undefined, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.I,
            title: "Project Items",
            url: "/projects/" + projectId + "/items"
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/projects"
    });

    return menu;
};

export function ProjectDiscussionSubMenu(projectId: number, discussionId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProjectDiscussionView, undefined, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/projects/${projectId}/discussions/${discussionId}/details`
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/projects/${projectId}/discussions`
    });

    return menu;
};

export function TrialProjectSubMenu(trialId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProjectView, undefined, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: "/trials/" + trialId + "/project/details"
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProjectDiscussionView, undefined, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.COMMENTS,
            title: "Discussions",
            url: "/trials/" + trialId + "/project/discussions"
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProjectView, undefined, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.I,
            title: "Project Items",
            url: "/trials/" + trialId + "/project/items"
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialId}/details`
    });

    return menu;
};

export function TrialProjectDiscussionSubMenu(trialId: number, discussionId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProjectView, undefined, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialId}/project/discussions/${discussionId}/details`
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialId}/project/discussions`
    });

    return menu;
};

export function SettingsGeneralSubMenu(permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.RolesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.USERSHIELD,
            title: "Roles",
            url: "/settings/general/roles",
            description: "Define and manage user roles and permissions."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.CountriesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.EARTHOCEANIA,
            title: "Countries",
            url: "/settings/general/countries",
            description: "Manage country information used within the system."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.StatesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.ROUTEINTERSTATE,
            title: "States",
            url: "/settings/general/states",
            description: "Manage states or provinces related to countries."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ItemComponentTypesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.LISTTIMELINE,
            title: "Item Component Types",
            url: "/settings/general/itemcomponenttypes",
            description: "Define types of components used in system items."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.NoteTypesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.LISTRADIO,
            title: "Note Types",
            url: "/settings/general/notetypes",
            description: "Manage different types of notes used in the system."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InterestsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.STOMACH,
            title: "Interests",
            url: "/settings/general/interests",
            description: "Manage user interests and areas of focus."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.MembershipTypesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.PEOPLEGROUP,
            title: "Membership Types",
            url: "/settings/general/membershiptypes",
            description: "Define and manage different types of memberships."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProfessionalDisciplinesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.USERDOCTOR,
            title: "Professional Disciplines",
            url: "/settings/general/professionaldisciplines",
            description: "Manage and categorize professional disciplines."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.SalutationsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.PERSONHALFDRESS,
            title: "Salutations",
            url: "/settings/general/salutations",
            description: "Manage available salutations for users."
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/settings/general",
        // description: "Return to the main settings menu."
    });

    return menu;
};

export function SettingsProjectsSubMenu(permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: any = []; 
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProjectItemTemplatesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FOLDERS,
            title: "Item Templates",
            url: "/settings/project/itemtemplates",
            description: "Manage predefined templates for project items."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProjectItemComponentsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.SOLARSYSTEM,
            title: "Item Components",
            url: "/settings/project/itemcomponents",
            description: "Define and manage components that make up project items."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProjectItemCategoriesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.SHAPES,
            title: "Item Categories",
            url: "/settings/project/itemcategories",
            description: "Categorise project items for better organization and filtering."
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/settings/project",
        // description: "Return to the main project settings menu."
    });

    return menu;
};


export function SettingsTrialSubMenu(permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: any[] = []; 
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialItemView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FOLDERS,
            title: "Item Templates",
            url: "/settings/trial/itemtemplates",
            description: "Manage predefined templates for trial items."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ItemComponentsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.SOLARSYSTEM,
            title: "Item Components",
            url: "/settings/trial/itemcomponents",
            description: "Define and manage components that make up trial items."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.CategoriesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.SHAPES,
            title: "Item Categories",
            url: "/settings/trial/itemtemplatecategories",
            description: "Organize trial items into different categories."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialTypesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.ATOMSIMPLE,
            title: "Trial Types",
            url: "/settings/trial/trialtypes",
            description: "Define and categorize different types of clinical trials."
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/settings/trial",
        // description: "Return to the main settings menu."
    });

    return menu;
};

export function SettingsTrialInstitutionSubMenu(permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: any[] = []; 
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialInstitutionItemTemplatesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FOLDERS,
            title: "Items Templates",
            url: "/settings/trialinstitution/itemtemplates",
            description: "Manage predefined templates for trial institution items."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialInstitutionItemComponentsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.SOLARSYSTEM,
            title: "Items Components",
            url: "/settings/trialinstitution/itemcomponents",
            description: "Define and manage components that make up trial institution items."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialInstitutionItemTemplateCategoriesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.SHAPES,
            title: "Item Categories",
            url: "/settings/trialinstitution/itemtemplatecategories",
            description: "Organize trial institution items into different categories."
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/settings/trialinstitution",
        // description: "Return to the main settings menu."
    });

    return menu;
};

export function SettingsTrialGroupSubMenu(permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: any[] = []; 
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupItemTemplatesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FOLDERS,
            title: "Items Templates",
            url: "/settings/trialgroup/itemtemplates",
            description: "Manage predefined templates for trial group items."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupItemComponentsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.SOLARSYSTEM,
            title: "Items Components",
            url: "/settings/trialgroup/itemcomponents",
            description: "Define and manage components that make up trial group items."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialGroupItemTemplateCategoriesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.SHAPES,
            title: "Item Categories",
            url: "/settings/trialgroup/itemtemplatecategories",
            description: "Organize trial group items into different categories."
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/settings/trialgroup",
        // description: "Return to the main settings menu."
    });

    return menu;
};

export function SettingsGroupsSubMenu(permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: any = []; 
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupItemTemplatesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FOLDERS,
            title: "Item Templates",
            url: "/settings/group/itemtemplates",
            description: "Manage predefined templates for group items."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupItemComponentsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.SOLARSYSTEM,
            title: "Item Components",
            url: "/settings/group/itemcomponents",
            description: "Define and manage components that make up group items."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.GroupItemCategoriesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.SHAPES,
            title: "Item Categories",
            url: "/settings/group/itemcategories",
            description: "Categorise group items for better organization and filtering."
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/settings/group",
        // description: "Return to the main settings menu."
    });

    return menu;
};

export function SettingsInstitutionsSubMenu(permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: any = []; 
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionItemUpdate)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FOLDERS,
            title: "Items Templates",
            url: "/settings/institution/itemtemplates",
            description: "Manage predefined templates for institution items."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionItemComponentsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.SOLARSYSTEM,
            title: "Item Components",
            url: "/settings/institution/itemcomponents",
            description: "Define and manage components that make up institution items."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionItemTemplateCategoriesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.SHAPES,
            title: "Item Categories",
            url: "/settings/institution/itemtemplatecategories",
            description: "Categorise institution items for better organization and filtering."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.SiteLocationsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.BUILDINGFLAG,
            title: "Site Locations",
            url: "/settings/institution/sitelocations",
            description: "Manage and configure institution site locations."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.KeyContactsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.ADDRESSBOOK,
            title: "Key Contacts",
            url: "/settings/institution/keycontacts",
            description: "Maintain key contacts associated with institutions."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.FacilityAllianceMembersView )) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.KAZOO,
            title: "Facility Alliance Members",
            url: "/settings/institution/facilityalliancemembers",
            description: "Manage members within the institution's facility alliance."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionTypesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.HOUSEMEDICAL,
            title: "Institution Types",
            url: "/settings/institution/institutiontypes",
            description: "Define and categorize different types of institutions."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionCodingView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CODE,
            title: "Institution Coding",
            url: "/settings/institution/institutioncodings",
            description: "Configure coding systems for institutions."
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/settings/institution",
        // description: "Return to the main settings menu."
    });

    return menu;
};

export function SettingsQASubMenu(permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: any = []; 
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.FormTemplatesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FOLDERS,
            title: "Form Templates",
            url: "/settings/qa/formtemplates",
            description: "Manage predefined templates for QA forms."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.FormComponentsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.SOLARSYSTEM,
            title: "Form Components",
            url: "/settings/qa/formcomponents",
            description: "Define and manage reusable components for QA forms."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ReportingTagsView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.TAGS,
            title: "Reporting Tags",
            url: "/settings/qa/reportingtags",
            description: "Configure tags for categorizing QA reports."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ReportingTagCategoriesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.SHAPES,
            title: "Reporting Tag Categories",
            url: "/settings/qa/reportingtagcategories",
            description: "Organize reporting tags into meaningful categories."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TaskTypesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.BARSPROGRESS,
            title: "Task Types",
            url: "/settings/qa/tasktypes",
            description: "Define different types of QA-related tasks."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TaskTypesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.WAVESSINE,
            title: "Tracker Types",
            url: "/settings/qa/trackertypes",
            description: "Manage different tracker types for QA monitoring."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TaskTypesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.TROPHY,
            title: "Tracker Milestones",
            url: "/settings/qa/trackermilestones",
            description: "Set up milestones for progress tracking in QA workflows."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.FormTemplateFileTypesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FILES,
            title: "File Types",
            url: "/settings/qa/formtemplatefiletypes",
            description: "Define allowed file types for QA form templates."
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.QAEmailTemplatesView)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.INBOXES,
            title: "Email Templates",
            url: "/settings/qa/qaemailtemplates",
            description: "Manage email templates for QA-related notifications."
        });
    }
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/settings/qa",
        // description: "Return to the main QA settings menu."
    });

    return menu;
};

export function LaboratorySubMenu(laboratoryId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.LabView, undefined, laboratoryId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/labs/${laboratoryId}/details`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.LabDepartmentView, undefined, laboratoryId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.BUILDINGMEMO,
            title: "Departments",
            url: `/labs/${laboratoryId}/departments`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.LabPersonnelView, undefined, laboratoryId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.USER,
            title: "Personnel",
            url: `/labs/${laboratoryId}/personnel`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.LabInstitutionView, undefined, laboratoryId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.INSTITUTION,
            title: "Institutions",
            url: `/labs/${laboratoryId}/institutions`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.LabFinanceView, undefined, laboratoryId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.MONEYCHECKDOLLARPEN,
            title: "Finance",
            url: `/labs/${laboratoryId}/finance`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.LabContractView, undefined, laboratoryId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FILECONTRACT,
            title: "Contract",
            url: `/labs/${laboratoryId}/contract`
        });
    }
    
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: "/labs"
    });

    return menu;
};

export function LaboratoryDepartmentSubMenu(laboratoryId: number, laboratoryDepartmentId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.LabDepartmentView, undefined, laboratoryDepartmentId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/labs/${laboratoryId}/departments/${laboratoryDepartmentId}/details`
        });
    }
    
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/labs/${laboratoryId}/departments`
    });

    return menu;
};

export function LaboratoryPersonnelSubMenu(laboratoryId: number, laboratoryPersonnelId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.LabPersonnelView, undefined, laboratoryPersonnelId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/labs/${laboratoryId}/personnel/${laboratoryPersonnelId}/details`
        });
    }
    
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/labs/${laboratoryId}/personnel`
    });

    return menu;
};

export function LaboratoryInstitutionSubMenu(laboratoryId: number, laboratoryInstitutionId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.LabInstitutionView, undefined, laboratoryInstitutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/labs/${laboratoryId}/institutions/${laboratoryInstitutionId}/details`
        });
    }
    
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/labs/${laboratoryId}/institutions`
    });

    return menu;
};

export function InstitutionLaboratorySubMenu(institutionId: number, laboratoryInstitutionId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.LabInstitutionView, undefined, laboratoryInstitutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/institutions/${institutionId}/labs/${laboratoryInstitutionId}/details`
        });
    }
    
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/institutions/${institutionId}/labs`
    });

    return menu;
};

export function InstitutionPersonnelSubMenu(institutionId: number, trialPersonnelId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionPersonnelView, undefined, trialPersonnelId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/institutions/${institutionId}/personnel/${trialPersonnelId}/details`
        });
    }
    
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/institutions/${institutionId}/personnel`
    });

    return menu;
};

export function TrialPersonnelSubMenu(trialId: number, trialPersonnelId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialPersonnelRoleView, trialId, trialPersonnelId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialId}/personnel/${trialPersonnelId}/details`
        });
    }
    
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialId}/personnel`
    });

    return menu;
};

export function InstitutionProcedureSubMenu(institutionId: number, institutionProcedureId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InstitutionProcedureView, undefined, institutionId)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/institutions/${institutionId}/procedures/${institutionProcedureId}/details`
        });
    }
    
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/institutions/${institutionId}/procedures`
    });

    return menu;
};

export function MonitoringSubMenu(trialId: number, trialInstitutionId: number, monitoringId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.MonitoringView, undefined, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/details`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.MonitoringDocumentView, undefined, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FILE,
            title: "Documents",
            url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/documents`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.MonitoringIssueView, undefined, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.MONITORINGISSUE,
            title: "Issues",
            url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues`
        });
    }
    
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring`
    });

    return menu;
};

export function MonitoringDocumentSubMenu(trialId: number, trialInstitutionId: number, monitoringId: number, monitoringDocumentId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.MonitoringDocumentView, undefined, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/documents/${monitoringDocumentId}/details`
        });
    }
    
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/documents`
    });

    return menu;
};

export function MonitoringIssueSubMenu(trialId: number, trialInstitutionId: number, monitoringId: number, monitoringIssueId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.MonitoringIssueView, undefined, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues/${monitoringIssueId}/details`
        });
    }
    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.MonitoringIssueDocumentView, undefined, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.FILE,
            title: "Documents",
            url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues/${monitoringIssueId}/documents`
        });
    }
    
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues`
    });

    return menu;
};

export function MonitoringIssueDocumentSubMenu(trialId: number, trialInstitutionId: number, monitoringId: number, monitoringIssueId: number, monitoringIssueDocumentId: number, permissions: Dtos.PersonnelTmdPermissions[]): INavItem[] {
    let menu: INavItem[] = [];

    if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.MonitoringIssueDocumentView, undefined, undefined)) {
        menu.push({
            icon: FontAwesomeIcons.Duotone.CIRCLEINFO,
            title: "Details",
            url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues/${monitoringIssueId}/documents/${monitoringIssueDocumentId}/details`
        });
    }
    
    menu.push({
        icon: FontAwesomeIcons.Duotone.LEFTTOLINE,
        title: "Back",
        url: `/trials/${trialId}/trialinstitution/${trialInstitutionId}/monitoring/${monitoringId}/issues/${monitoringIssueId}/documents`
    });

    return menu;
};